export class AppObjectPool
{
    public static SCENE_KEY: string = "objectPool";
    public static scene: Phaser.Scene;
    public static objectPool: Phaser.GameObjects.Container;
    /**
     * Objects that when pooled do not have group specified, are added to default group
     */
    public static DEFAULT_GROUP: string = "default";
    private static objectsByGroup: any[][];


    public static Init(scene: Phaser.Scene): void
    {
        this.scene = scene.scene.add(this.SCENE_KEY, ObjectPoolScene, false); // autostart: false makes dropped objects invis
        this.objectPool = this.scene.make.container({});
        this.objectsByGroup = [];
        this.objectsByGroup[this.DEFAULT_GROUP] = [];
    }
    // findComponent<ComponentType>(go: IComponentGameObject, componentType: Constructor<ComponentType>)
	// {
	// 	const components = this.componentsByGameObject.get(go.cid) ?? []
	// 	return components.find(component => component instanceof componentType) as unknown as ComponentType | undefined
	// }

    /**
     * 
     * @param go 
     * @param classType 
     * @param group If this is specifiefd, assigns group to object.
     *  When grabbing object by group, only object with same group can be retrieved.
     *  If unspecified, object is added to @see DEFAULT_GROUP.
     */
    public static DropObject(go: any, group?: string): void
    {
        group = group ? group : this.DEFAULT_GROUP;

        if (this.objectsByGroup[group] == undefined) {
            this.objectsByGroup[group] = [];
        }

        this.objectsByGroup[group].push(go);
        this.objectPool.add(go);
    }

    public static PickObject(group?:string): any | null
    {
        group = group ? group : this.DEFAULT_GROUP;

        if (this.objectsByGroup[group] && this.objectsByGroup[group].length > 0) {
            // console.log(`ObjectPool group objects count (${group}): ${this.objectsByGroup[group].length}`);
            // array modified in place
            // returns removed item
            const removedItem: any = Phaser.Utils.Array.RemoveAt(this.objectsByGroup[group], this.objectsByGroup[group].length - 1);
            this.objectPool.remove(removedItem);
            // console.log("got from pool:",removedItem.name);
            return removedItem;
        }

        return null;
    }

    public static GetObjectsCount(group: string = undefined): number
    {
        if (group == undefined) {
            group = this.DEFAULT_GROUP;
        }
        if (this.objectsByGroup[group] == undefined) {
            // -1 = 'no such group'
            return -1;
        }
        return this.objectsByGroup[group].length;
    }

    public static GetObjects(group: string = undefined): any[]
    {
        if (group == undefined) {
            group = this.DEFAULT_GROUP;
        }
        return this.objectsByGroup[group];
    }
}

export class ObjectPoolScene extends Phaser.Scene {}